"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
// Note: this component is only used for providing example markup to the styleguide.
// Do not import it directly into the application.
function Tooltip() {
    return ((0, jsx_runtime_1.jsxs)("div", { children: ["Some text that needs extra copy.", (0, jsx_runtime_1.jsx)("div", { className: "tooltip-block", children: (0, jsx_runtime_1.jsxs)("div", { className: "tooltip-item", children: ["?", (0, jsx_runtime_1.jsx)("div", { className: "tooltip", children: "Some additional copy." })] }) })] }));
}
exports.default = Tooltip;
